import {gql, useQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query FooterLinks($locale: String!){
	menuSectionCollection(
        limit:4,
        locale: $locale,
        order: sequence_ASC
        ){
		items{
			title
			title_en_gb: title(locale: "en-GB")
            sequence
			linkedObjectsCollection{
				items{
					...on MenuLinks{
						label
			            label_en_gb: label(locale: "en-GB")
						internalUrl
						url
						contentPage{
							slug
						}
					}
				}
			}
		}
	}
}
`;
export const useFooterLinks = () => {
    const {logger} = useLogger();
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {loading, data, error} = useQuery(QUERY, {variables: {locale: localeUppercase}});

    const collection = data?.menuSectionCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useFooterLinks", error?.stack);
    }

    return {
        collection,
        errorFooter: error,
        loadingFooter: loading
    };
};
